module.exports = __webpack_public_path__ + "assets/img/bt_logo_tr.png?bb84a9fe860099b3462fcf0b0ef45973";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bt_logo_tr.png
// module id = 1132
// module chunks = 0